import React,{useEffect} from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import moment from "moment";
import "./DetaljiTable.css";
import { ZoomInOutlined, PaperClipOutlined } from "@ant-design/icons";
import RazlogBrisanjaComponent from "./RazlogBrisanjaComponent";

const povezanaDrustvaDetaljiTable = (props) => {
  let osoba;
  let adresaOsobe;
  let registracijaOsobe = [];
  let osobaDrustvo = [];
  let dokumentOsobe;
  let mjere = [];
  let clanstva = [];

  let povezanaDrustva = [];
  let odobrenjeZaRad = [];
  let odobrenjeOdrzivosti = [];

  let registar = props.children;

  osoba = registar[1];
  adresaOsobe = registar[2];
  registracijaOsobe = registar[3];
  osobaDrustvo = registar[4];
  dokumentOsobe = registar[5];
  mjere = registar[7];
  clanstva = registar[8];
  odobrenjeOdrzivosti = registar[9];

  povezanaDrustva = osobaDrustvo.filter((x) => x.vrVeze != 2);
  //Osim drustava u kojem je osoba 'Ovlašteni revizor', dodaju se i sva društva u kojima je 'Član'
  //Ukoliko u nekom društvu ima više funkcija, spajaju se u jedan redak tablice, u suprotnom ide novi
  povezanaDrustva.forEach((element)=>{
    element.funkcije = ["Ovlašteni revizor"];
  })
  if(clanstva.length !== 0){
    clanstva.forEach((clanstvo)=>{
      let nePostoji = true;
      povezanaDrustva.forEach((element)=>{
        if(clanstvo.idDrustva === element.idDrustva){
          element.funkcije.push(clanstvo.funkcija);
          nePostoji = false;
        }
      });
      if(nePostoji){
        povezanaDrustva.push({
          idDrustva: clanstvo.idDrustva,
          vrDrustva: clanstvo.vrDrustva,
          nazivDrustva: clanstvo.nazivDrustva, 
          funkcije:[clanstvo.funkcija],
          oibDrustva: clanstvo.oib,
          idBrojDrustva: clanstvo.idBroj,
          regBrojDrustva: clanstvo.regBroj,
        })
      }
    })
  }

  povezanaDrustva.sort((a,b)=>{
    let nazivA = a.nazivDrustva ? a.nazivDrustva : a.imeDrustva + " " + a.prezimeDrustva ;
    let nazivB= b.nazivDrustva ? b.nazivDrustva : b.imeDrustva + " " + b.prezimeDrustva ;
    return nazivA.localeCompare(nazivB);
  })

  odobrenjeZaRad = registracijaOsobe.filter(
    (x) => x.vrRegistracije == 1
  );

  let regDrugeDrzave = registracijaOsobe.filter((x) => x.vrRegistracije == 2);
  let nadleznoTijelo = registracijaOsobe.filter((x) => x.vrRegistracije == 3);

  const noDataMessage = "";

  const { userRole } = props;
  const checkIfUserIsAdmin =
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

  const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  };

  return (
    <div id="printArea">
      {osoba.napomena ? (
        <RazlogBrisanjaComponent razlog={osoba.napomena} />
      ) : null}
      <h5>Pregled podataka</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ovlašteni revizor</th>
            {checkIfUserIsAdmin ? <th scope="col">OIB</th> : null}
            <th scope="col">Registarski broj</th>
            <th scope="col">Broj i datum odobrenja za rad</th>
            <th scope="col">Broj i datum odobrenja za rad za obavljanje provjere izvještaja o održivosti</th>
            {checkIfUserIsAdmin ? <th scope="col">Adresa</th> : null}
            {checkIfUserIsAdmin ? <th scope="rowgroup">Kontakt</th> : null}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {osoba.ime} {osoba.prezime}
            </td>
            {checkIfUserIsAdmin ? <td>{osoba.oib}</td> : null}
            <td>{osoba.regBroj}</td>
            <td className="hr-divider">
              {odobrenjeZaRad.map((element) => (
                <>
                  <table>
                    {!element.brReg && !element.datReg ? (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Izdavatelj: </b>
                            Hrvatska revizorska komora
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj odobrenja za rad: </b>
                            {element.brReg}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum odobrenja za rad: </b>
                            {element.datReg}
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                  <hr />{" "}
                </>
              ))}
            </td>
            <td className="hr-divider">
                <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Broj odobrenja za rad za obavljanje provjere izvještaja o održivosti: </b>
                          {odobrenjeOdrzivosti.brojOdrzivosti}
                        </td>
                      </tr>
                      <tr>
                        <td className="inner-td">
                          <b>Datum odobrenja za rad za obavljanje provjere izvještaja o održivosti: </b>
                          {odobrenjeOdrzivosti.datumOdrzivosti}
                        </td>
                      </tr>
                    </tbody>
                </table>
            </td>
            {checkIfUserIsAdmin ? (
              <>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td className="inner-td">
                        <b>Ulica i kbr: </b>
                        {adresaOsobe.ulicaKbr
                          ? adresaOsobe.ulicaKbr
                          : noDataMessage}
                      </td>
                    </tr>
                    {adresaOsobe.brPoste || adresaOsobe.nazNaselja ? (
                      <tr>
                        <td className="inner-td">
                          <b>Grad: </b>
                          {adresaOsobe.brPoste}
                          {adresaOsobe.nazNaselja &&
                            " " + adresaOsobe.nazNaselja}
                        </td>
                      </tr>
                    ) : null}

                    {adresaOsobe.drzava ? (
                      <tr>
                        <td className="inner-td">
                          <b>Država: </b>
                          {adresaOsobe.drzava}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </td>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td className="inner-td">
                        <b>Telefon:</b>
                        {" "}{osoba.telefon}
                      </td>
                    </tr>
                    <tr>
                      <td className="inner-td">
                        <b>E-mail:</b>
                        {" "}{osoba.email}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              </>
            ) : null}
          </tr>
        </tbody>
      </Table>

      <h5>Ovlašteni revizor zaposlen u revizorskim subjektima ili je s njima povezan na drugi način</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv / ime i prezime</th>
            <th scope="col">OIB</th>
            <th scope="col">Registarski broj</th>
            {/* prikazuje se funkcija (član tima / revizor / prokurist) */}
            <th scope="col">Opis</th>
            <th scope="col">Detalji</th>
          </tr>
        </thead>
        <tbody>
          {povezanaDrustva.length > 0 ? (
            povezanaDrustva.map((povezanoDrustvo, index) => (
              <tr key={`tr-povezana-drustva${index}`}>
                <td>
                  {povezanoDrustvo.nazivDrustva
                    ? povezanoDrustvo.nazivDrustva
                    : povezanoDrustvo.imeDrustva +
                      " " +
                      povezanoDrustvo.prezimeDrustva}
                </td>
                <td x-ms-format-detection="none">
                  {povezanoDrustvo.oibDrustva
                    ? povezanoDrustvo.oibDrustva
                    : povezanoDrustvo.idBrojDrustva +
                      " (Identifikacijski broj)"}
                </td>
                <td>{povezanoDrustvo.regBrojDrustva}</td>
                <td>{povezanoDrustvo.funkcije.map((funk)=>
                      <tr className="inner-tr">
                        <td className="td-no-border">
                          {funk}
                        </td>
                      </tr>
                    )}
                </td>
                <td className="ant_batn">
                  <ButtonComponent
                    variant="secondary"
                    onClick={(e) =>
                      props.detaljiSecondaryClicked(
                        "drustvo",
                        povezanoDrustvo.idDrustva,
                        povezanoDrustvo.vrDrustva,
                        false
                      )
                    }
                  >
                    <ZoomInOutlined />
                  </ButtonComponent>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Registracija kod nadležnog tijela drugih država članica i kao revizora
        kod nadležnog tijela u trećim zemljama
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum registracije</th>
          </tr>
        </thead>
        <tbody>
          {regDrugeDrzave.length > 0 ? (
            regDrugeDrzave.map((reg, index) =>
              !reg.brReg &&
              !reg.datReg &&
              !reg.nazTijela &&
              !reg.ulicaKbr &&
              !reg.brPoste &&
              !reg.nazNaselja ? (
                <tr key={`tr-reg-dr-drz${index}`}>
                  <td colSpan="3"></td>
                </tr>
              ) : (
                <tr key={`tr-reg-dr-drz${index}`}>
                  <td>{reg.nazTijela ? reg.nazTijela : noDataMessage}</td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {reg.ulicaKbr ? reg.ulicaKbr : noDataMessage}
                          </td>
                        </tr>
                        {reg.brPoste || reg.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {reg.brPoste}
                              {reg.nazNaselja && " " + reg.nazNaselja}
                            </td>
                          </tr>
                        ) : null}

                        {reg.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {reg.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj registracije: </b>
                            {reg.brReg ? reg.brReg : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum registracije: </b>
                            {reg.datReg ? reg.datReg : noDataMessage}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Nadležno tijelo države članice odgovorno za odobrenje, registraciju,
        nadzor osiguranja kvalitete rada i nadzor ovlaštenih revizora i
        revizorskih društava
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
          </tr>
        </thead>
        <tbody>
          {nadleznoTijelo.length > 0 ? (
            nadleznoTijelo.map((reg, index) =>
              !reg.nazTijela &&
              !reg.ulicaKbr &&
              !reg.brPoste &&
              !reg.nazNaselja ? (
                <tr key={`tr-nadlezno${index}`}>
                  <td colSpan="2"></td>
                </tr>
              ) : (
                <tr key={`tr-nadlezno${index}`}>
                  <td>{reg.nazTijela ? reg.nazTijela : noDataMessage}</td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {reg.ulicaKbr ? reg.ulicaKbr : noDataMessage}
                          </td>
                        </tr>
                        {reg.brPoste || reg.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {reg.brPoste}
                              {reg.nazNaselja && " " + reg.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {reg.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {reg.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="2"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Izrečene odluke i nadzorne mjere</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Vrsta mjere</th>
            <th scope="col">Rješenje</th>
            <th scope="col">Broj i datum rješenja</th>
            {checkIfUserIsAdmin ? (
              <th scope="col">Datum dostave rješenja subjektu</th>
            ) : null}
            {/* <th scope="col">Napomena</th> */}
            <th scope="col">Upravni spor</th>
            <th scope="col">Datum pravomoćnosti</th>
            <th scope="col">Prekršajni postupak</th>
            {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
              <th scope="col">Datum brisanja</th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {mjere.length ? (
            mjere.map((mjera, index) => (
              <tr key={`tr-mjere${index}`}>
                <td>{mjera.vrstaMjere ? mjera.vrstaMjere : noDataMessage}</td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentOsoba(e, mjera.idMjereOsobe)
                    }
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Broj rješenja: </b>
                          {mjera.brRjesenja ? mjera.brRjesenja : noDataMessage}
                        </td>
                      </tr>
                      <tr>
                        <td className="inner-td">
                          <b>Datum rješenja: </b>
                          {mjera.datRjesenja
                            ? mjera.datRjesenja
                            : noDataMessage}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin ? (
                  <td>
                    {mjera.datPreuzimanja
                      ? mjera.datPreuzimanja
                      : noDataMessage}
                  </td>
                ) : null}
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentUSOsoba(e, mjera.idMjereOsobe)
                    }
                    disabled={mjera.nazivDok2 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena2 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena2}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>

                <td>
                  {mjera.datPravomocnosti
                    ? mjera.datPravomocnosti
                    : noDataMessage}
                </td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentPPOsoba(e, mjera.idMjereOsobe)
                    }
                    disabled={mjera.nazivDok3 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena3 ? (
                        <tr>
                          <td className="inner-td">
                            {" "}
                            <b>Napomena: </b>
                            {mjera.napomena3}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>

                {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
                  <td>
                    {mjera.datBrisanja ? mjera.datBrisanja : noDataMessage}
                  </td>
                ) : null}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8"></td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default povezanaDrustvaDetaljiTable;
